import { render, staticRenderFns } from "./ScholarshipTypesSelectbox.vue?vue&type=template&id=d0b9123c"
import script from "./ScholarshipTypesSelectbox.vue?vue&type=script&lang=js"
export * from "./ScholarshipTypesSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports